/* KAYTEA — cart uses the Shopify AJAX API; every block guards its own root */
/* ============================================================
   DATA — single source of truth. Port straight to Liquid schema.
   ============================================================ */
const FLAVOURS = [
  { id:'lemon', handle:'lemon-zest-cold-brew-ice-tea', name:'Lemon Zest', word:'Lemon<br>Zest', caffeine:4, caffeineLabel:'High',
    tea:'Black Tea', teaVar:'--tea-black', sugar:'3.5g', kcal:'13kcal',
    note:'Amalfi Coast lemon over black tea. Sharp, clean, no sugar hangover.',
    d:'--lemon-d', l:'--lemon-l',
    img:'https://cdn.shopify.com/s/files/1/0827/3690/6564/files/lemon-zest-new.png?v=1786532692' },

  { id:'peach', handle:'white-peach-cold-brew-ice-tea', name:'White Peach', word:'White<br>Peach', caffeine:3, caffeineLabel:'Medium',
    tea:'Green Tea', teaVar:'--tea-green', sugar:'3.5g', kcal:'13kcal',
    note:'Green tea with ripe stone fruit. Steady lift, no jitters.',
    d:'--peach-d', l:'--peach-l',
    img:'https://cdn.shopify.com/s/files/1/0827/3690/6564/files/white-peach-new.png?v=1786532692' },

  { id:'jasmine', handle:'jasmine-grapefruit-cold-brew-ice-tea', name:'Jasmine Grapefruit', word:'Jasmine<br>Grapefruit', caffeine:3, caffeineLabel:'Medium',
    tea:'Jasmine Green Tea', teaVar:'--tea-green', sugar:'4.5g', kcal:'17kcal',
    note:'Floral jasmine against bitter pink grapefruit. The most grown-up one.',
    d:'--jasmine-d', l:'--jasmine-l',
    img:'https://cdn.shopify.com/s/files/1/0827/3690/6564/files/jasmine-grapefruit-new.png?v=1786532692' },

  { id:'grape', handle:'ice-tea-blackcurrant-grape', name:'Blackcurrant Grape', word:'Blackcurrant<br>Grape', caffeine:3, caffeineLabel:'Medium',
    tea:'Oolong Tea', teaVar:'--tea-oolong', sugar:'3.5g', kcal:'13kcal', limited:true,
    note:'Dark fruit over roasted oolong. Here for a good time, not a long time.',
    d:'--grape-d', l:'--grape-l',
    img:'https://cdn.shopify.com/s/files/1/0827/3690/6564/files/blackcurrant-grape-new.png?v=1786532691' },

  { id:'mango', handle:'mango-yuzu-cold-brew-ice-tea', name:'Mango Yuzu', word:'Mango<br>Yuzu', caffeine:2, caffeineLabel:'Low',
    tea:'White Tea', teaVar:'--tea-white', sugar:'4.5g', kcal:'18.3kcal',
    note:'Delicate white tea, mango sweetness, yuzu on the finish. Easy going.',
    d:'--mango-d', l:'--mango-l',
    img:'https://cdn.shopify.com/s/files/1/0827/3690/6564/files/mango-yuzu-new.png?v=1786532692' },

  { id:'pineapple', handle:'pineapple-passionfruit-cold-brew-ice-tea', name:'Pineapple Passionfruit', word:'Pineapple<br>Passionfruit', caffeine:0, caffeineLabel:'None',
    tea:'Hibiscus', teaVar:'--tea-hibiscus', sugar:'3.5g', kcal:'13kcal',
    note:'Naturally caffeine free. Tropical on top, tart hibiscus underneath.',
    d:'--pineapple-d', l:'--pineapple-l',
    img:'https://cdn.shopify.com/s/files/1/0827/3690/6564/files/pineapple-passionfruit-new.png?v=1786532692' }
];

/* The six ice teas plus the sampler set as a seventh card.
   Infusions and powders are being discontinued, so the range is a
   single list — no category tabs. */
const RANGE = [
  ...FLAVOURS.map(f => ({
    title:f.name, sub:f.tea, price:'£19.99', d:f.d, l:f.l, img:f.img, handle:f.handle,
    flag:f.limited ? 'Limited edition' : (f.caffeineLabel === 'None' ? 'Caffeine free' : null)
  })),
  {
    title:'6 Pack Sample', handle:'ice-tea-6-pack-sample',
    sub:'One of every flavour', price:'£14.99',
    d:'--sampler-d', l:'--sampler-l', flag:'Best seller',
    img:'https://cdn.shopify.com/s/files/1/0827/3690/6564/files/6-pack-sampler.png?v=1786706301'
  }
];

/* ============================================================
   RESPONSIVE IMAGES
   Shopify's CDN resizes and format-negotiates from a width param,
   so one master PNG serves a right-sized WebP at every breakpoint.
   ============================================================ */
const WIDTHS = [300, 450, 600, 800, 1100];

function srcset(url){
  if (!url.includes('cdn.shopify.com')) return null;
  const sep = url.includes('?') ? '&' : '?';
  return WIDTHS.map(w => `${url}${sep}width=${w} ${w}w`).join(', ');
}

function responsive(img, url, sizes){
  const ss = srcset(url);
  if (ss){ img.srcset = ss; img.sizes = sizes; }
  img.src = url;
}

/* ============================================================
   FLAVOUR SWITCHER
   ============================================================ */
const root = document.documentElement;
const stage = document.querySelector('.stage');
const rail = document.getElementById('rail');
let active = 4; // Mango Yuzu — matches the hero can

if (stage && rail) FLAVOURS.forEach((f, i) => {
  const img = document.createElement('img');
  img.className = 'stage-can';
  responsive(img, f.img, '(max-width: 899px) 45vw, 26vw');
  img.alt = `KAYTEA ${f.name} can`;
  img.loading = 'lazy';
  img.onerror = () => { img.classList.add('no-img'); img.removeAttribute('src'); };
  stage.appendChild(img);

  const b = document.createElement('button');
  b.type = 'button';
  b.setAttribute('role','tab');
  b.innerHTML = `<span class="dot"></span>${f.name}`;
  b.style.setProperty('--dot', `var(${f.d})`);
  b.addEventListener('click', () => select(i));
  rail.appendChild(b);
});

/* These threw a TypeError on any page without the flavour switcher,
   which killed the rest of the file — including the cart refresh. */
const cans = stage ? [...stage.querySelectorAll('.stage-can')] : [];
const railBtns = rail ? [...rail.querySelectorAll('button')] : [];

function select(i){
  if (!stage || !rail) return;
  active = i;
  const f = FLAVOURS[i];

  root.dataset.flavour = f.id;
  syncFlavourDecor();
  root.style.setProperty('--accent-d', `var(${f.d})`);
  root.style.setProperty('--accent-l', `var(${f.l})`);

  cans.forEach((c, n) => c.classList.toggle('active', n === i));
  railBtns.forEach((b, n) => b.setAttribute('aria-selected', n === i));

  const stageWord = document.getElementById('stageWord');
  stageWord.innerHTML = f.word;
  /* Long flavour names shrink so the outline word never overruns the stage */
  const longest = Math.max(...f.word.split('<br>').map(w => w.length));
  stageWord.style.setProperty('--word-scale', Math.min(1, 6.5 / longest).toFixed(2));

  document.getElementById('detailName').textContent = f.name;
  document.getElementById('detailNote').textContent = f.note;
  document.getElementById('specTea').textContent = f.tea;
  document.getElementById('specSugar').textContent = f.sugar;
  document.getElementById('specKcal').textContent = f.kcal;
  document.getElementById('meterText').textContent = f.caffeineLabel;

  [...document.getElementById('meterBars').children]
    .forEach((bar, n) => bar.classList.toggle('on', n < f.caffeine));

  const badges = document.getElementById('badges');
  badges.innerHTML = '';
  const tea = document.createElement('span');
  tea.className = 'badge badge--tea';
  tea.style.setProperty('--tea-colour', `var(${f.teaVar})`);
  tea.textContent = f.tea;
  badges.appendChild(tea);
  if (f.limited){
    const lim = document.createElement('span');
    lim.className = 'badge badge--limited';
    lim.textContent = 'Limited edition';
    badges.appendChild(lim);
  }
}
if (stage && rail) select(active);

/* ============================================================
   RANGE TABS
   ============================================================ */
const tabs = document.getElementById('tabs');
const grid = document.getElementById('grid');

/* Tabs are no longer used — hidden rather than removed so the markup
   stays valid if the section is reused elsewhere. */
if (tabs) tabs.remove();

function renderRange(){
  if (!grid) return;
  grid.innerHTML = '';
  RANGE.forEach(p => {
    const card = document.createElement('article');
    card.className = 'card';
    card.style.setProperty('--c-d', `var(${p.d})`);
    card.style.setProperty('--c-l', `var(${p.l})`);
    card.innerHTML = `
      ${p.flag ? `<span class="flag">${p.flag}</span>` : ''}
      ${p.handle ? `<a class="card-link" href="/products/${p.handle}" aria-label="${p.title}"></a>` : ''}
      <div class="card-media"><img alt="${p.title}" loading="lazy"></div>
      <p class="card-tea">${p.sub}</p>
      <h3>${p.title}</h3>
      <div class="card-meta">
        <span class="card-price">${p.price}</span>
        <button class="add" type="button">${p.multi ? 'Choose' : 'Add'}</button>
      </div>`;
    const img = card.querySelector('img');
    img.onerror = () => card.classList.add('no-img');
    responsive(img, p.img, '(max-width: 640px) 90vw, (max-width: 1100px) 40vw, 22vw');
    card.querySelector('.add').addEventListener('click', e => addToCart(p.handle, e.target));
    grid.appendChild(card);
  });
}
renderRange();

/* ============================================================
   CART — Shopify AJAX API
   Variant IDs are looked up from the product handle at click time,
   so nothing here needs hardcoded IDs and it keeps working when
   products are edited in admin. If a handle 404s we fall through to
   the product page rather than failing silently.
   ============================================================ */
const drawer = document.getElementById('drawer');
const scrim  = document.getElementById('scrim');

const money = c => '£' + (c / 100).toFixed(2);

function toggleCart(open){
  if (!drawer || !scrim) return;
  drawer.classList.toggle('open', open);
  scrim.classList.toggle('open', open);
  drawer.setAttribute('aria-hidden', !open);
}
document.getElementById('cartOpen')?.addEventListener('click', () => toggleCart(true));
document.getElementById('cartClose')?.addEventListener('click', () => toggleCart(false));
scrim?.addEventListener('click', () => toggleCart(false));
document.addEventListener('keydown', e => { if (e.key === 'Escape') toggleCart(false); });

async function addToCart(handle, btn){
  if (!handle) return;
  const label = btn ? btn.textContent : '';
  if (btn){ btn.textContent = 'Adding…'; btn.disabled = true; }

  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error('product not found: ' + handle);
    const product = await res.json();

    /* More than one variant means a real choice (pouch vs sample, and
       different prices), so send them to the product page rather than
       guessing which size they meant. */
    if (product.variants.length > 1){
      window.location.href = '/products/' + handle;
      return;
    }

    const variant = product.variants.find(v => v.available) || product.variants[0];
    if (!variant) throw new Error('no variant');

    const add = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
    });
    if (!add.ok) throw new Error('add failed');

    await refreshCart();

    toggleCart(true);
    if (btn){ btn.textContent = 'Added'; btn.classList.add('done'); }
  } catch (err) {
    console.warn('KAYTEA cart:', err);
    window.location.href = '/products/' + handle;
    return;
  } finally {
    if (btn) setTimeout(() => {
      btn.textContent = label;
      btn.disabled = false;
      btn.classList.remove('done');
    }, 1400);
  }
}

/* ============================================================
   PRODUCT FORM INTERCEPT
   The theme adds to cart by calling form.submit() directly, which
   does NOT fire a submit event — so we intercept the click in the
   capture phase instead, before the theme's own handler runs.

   FormData is sent verbatim, so selling_plan (Subscribe & Save),
   quantity and any line item properties all carry through.
   ============================================================ */
async function kayteaAddFromForm(form, btn){
  const label = btn ? btn.textContent : '';
  if (btn){ btn.disabled = true; btn.textContent = 'Adding…'; }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    });
    if (!res.ok) throw new Error('add failed: ' + res.status);
    await refreshCart();
    toggleCart(true);
  } catch (err) {
    /* No redirect on failure — landing on /cart unexpectedly is worse
       than staying put. The button resets so it can be retried. */
    console.warn('KAYTEA cart:', err);
  } finally {
    if (btn){ btn.disabled = false; btn.textContent = label; }
  }
}

function kayteaCartForm(el){
  const form = el.closest('form[action*="/cart/add"]');
  if (!form) return null;
  if (!form.querySelector('[name="id"]')) return null;
  return form;
}

/* Capture phase: runs before the theme's own click handler. */
document.addEventListener('click', e => {
  /* Leave Shop Pay and other dynamic checkout buttons alone. */
  if (e.target.closest('.shopify-payment-button, [data-shopify="payment-button"]')) return;

  const btn = e.target.closest('button, input[type="submit"]');
  if (!btn) return;
  if (btn.type === 'button' && !btn.matches('[name="add"], [class*="add-to-cart"], [class*="product-form__submit"]')) return;

  const form = kayteaCartForm(btn);
  if (!form) return;

  e.preventDefault();
  e.stopPropagation();
  kayteaAddFromForm(form, btn);
}, true);

/* Kept as a safety net for anything that does fire a real submit. */
document.addEventListener('submit', e => {
  const form = kayteaCartForm(e.target);
  if (!form) return;
  e.preventDefault();
  kayteaAddFromForm(form, form.querySelector('[type="submit"]'));
}, true);

(function watchCartRequests(){
  const nativeFetch = window.fetch;
  window.fetch = function(...args){
    const url = (args[0] && args[0].url) || String(args[0] || '');
    return nativeFetch.apply(this, args).then(res => {
      if (/\/cart\/(add|change|update|clear)/.test(url)) setTimeout(refreshCart, 120);
      return res;
    });
  };
})();


/* Cards rendered by Liquid (collection pages) rather than by this file
   still need to reach the cart, so bind by delegation. */
document.addEventListener('click', e => {
  const b = e.target.closest('.add[data-handle]');
  if (b) addToCart(b.dataset.handle, b);
});

async function changeLine(key, quantity){
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (res.ok) renderCart(await res.json());
  } catch (err) { console.warn('KAYTEA cart:', err); }
}

async function refreshCart(){
  try {
    const res = await fetch('/cart.js');
    if (res.ok) renderCart(await res.json());
  } catch (err) { console.warn('KAYTEA cart:', err); }
}

function renderCart(cart){
  const count = document.getElementById('cartCount');
  const body  = document.getElementById('drawerBody');
  const total = document.getElementById('cartTotal');
  if (count) count.textContent = cart.item_count;
  if (total) total.textContent = money(cart.total_price);
  if (!body) return;

  if (!cart.items.length){
    body.innerHTML = '<p class="drawer-empty">Nothing in here yet. Pick a flavour and we\'ll get it moving.</p>';
    return;
  }

  body.innerHTML = cart.items.map(i => `
    <div class="cart-line">
      <div>
        <b>${i.product_title}</b>
        <small>${i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title + ' · ' : ''}Qty ${i.quantity}</small>
        <button type="button" class="line-remove" data-key="${i.key}">Remove</button>
      </div>
      <span>${money(i.line_price)}</span>
    </div>`).join('');

  body.querySelectorAll('.line-remove').forEach(b =>
    b.addEventListener('click', () => changeLine(b.dataset.key, 0)));
}

document.querySelector('[data-add="flavour"]')?.addEventListener('click', e => {
  addToCart(FLAVOURS[active].handle, e.target);
});

refreshCart();

/* ============================================================
   DECOR LAYER
   Paste Shopify CDN URLs into DECOR_ASSETS. Any key left empty is
   skipped, so the page renders cleanly until the art arrives.

   Placement units are % of the section box.
   w    = width as % of section width
   r    = rotation in degrees
   o    = opacity
   d    = parallax depth; 0 is static, 0.3 drifts noticeably
   ============================================================ */
const CDN = 'https://cdn.shopify.com/s/files/1/0827/3690/6564/files/';
const V   = '?v=1786553300';

/* Each flavour owns two pieces: [primary, secondary].
   Every decoration on the page draws from this pair, so the whole
   page re-fruits when the flavour changes. */
const FLAVOUR_FRUIT = {
  peach:     [CDN+'peach-whole-transparent.png'+V,      CDN+'peach-slice-transparent.png'+V],
  lemon:     [CDN+'lemon-whole-transparent.png'+V,      CDN+'lemon-slice-transparent.png'+V],
  jasmine:   [CDN+'grapefruit-whole-transparent.png'+V, CDN+'grapefruit-slice-transparent.png'+V],
  grape:     [CDN+'grapes-transparent.png'+V,           CDN+'blackcurrants-transparent.png'+V],
  mango:     [CDN+'mango-transparent.png'+V,            CDN+'yuzu-transparent.png'+V],
  pineapple: [CDN+'pineapple-transparent.png'+V,        CDN+'passionfruit-transparent.png'+V]
};

/* Placement. Coordinates are % of the section box.
   pick = which of the flavour's two pieces to show (0 or 1)
   w = width as % of section width, r = rotation, o = opacity,
   d = parallax depth (0 static, .3 drifts noticeably)

   Keep `top` roughly between 6 and 68 so nothing straddles a
   section boundary and gets painted over by the next section. */
const DECOR = [
  { on:'.hero',     pick:1, top:8,  left:56, w:7,  r:-16, o:.9,  d:.18 },
  { on:'.hero',     pick:0, top:60, left:41, w:6,  r:14,  o:.85, d:.28, mobile:'hide' },

  { on:'.flavours', pick:0, top:6,  left:76, w:11, r:-14, o:.9,  d:.2 },
  { on:'.flavours', pick:1, top:54, left:2,  w:10, r:18,  o:.85, d:.24, mobile:'hide' },

  { on:'.clock',    pick:0, top:24, left:80, w:11, r:16,  o:.9,  d:.2 },
  { on:'.clock',    pick:1, top:60, left:66, w:7,  r:-28, o:.75, d:.28, mobile:'hide' },

  { on:'.story',    pick:1, top:10, left:47, w:9,  r:-10, o:.85, d:.24, mobile:'hide' },
  { on:'.story',    pick:0, top:66, left:5,  w:7,  r:30,  o:.8,  d:.18 },

  { on:'.reviews',  pick:0, top:16, left:88, w:7,  r:12,  o:.8,  d:.22, mobile:'hide' },
  { on:'.reviews',  pick:1, top:58, left:3,  w:7,  r:-20, o:.75, d:.26, mobile:'hide' },

  { on:'.signup',   pick:1, top:14, left:86, w:9,  r:20,  o:.8,  d:.2,  mobile:'hide' },
  { on:'.signup',   pick:0, top:58, left:3,  w:8,  r:-22, o:.8,  d:.26, mobile:'hide' }
];

var decorItems = [];
var flavourDecor = [];

(function buildDecor(){
  const layers = new Map();

  DECOR.forEach((item, i) => {
    const section = document.querySelector(item.on);
    if (!section) return;

    let layer = layers.get(item.on);
    if (!layer){
      section.classList.add('has-decor');
      layer = document.createElement('div');
      layer.className = 'decor';
      layer.setAttribute('aria-hidden','true');
      section.prepend(layer);
      layers.set(item.on, layer);
    }

    const piece = document.createElement('span');
    piece.className = 'piece';
    piece.style.top = item.top + '%';
    piece.style.left = item.left + '%';
    piece.style.setProperty('--w', item.w + '%');
    if (item.mobile) piece.dataset.mobile = item.mobile;

    const img = document.createElement('img');
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.style.setProperty('--o', item.o);
    img.style.setProperty('--r', (item.r || 0) + 'deg');

    /* Prime-ish steps so the cycle lengths don't line up, plus a
       negative delay so each piece starts mid-bob rather than all
       beginning together on load. */
    img.style.setProperty('--bob',   (5 + (i % 5) * 2.2).toFixed(1) + 'px');
    img.style.setProperty('--tilt',  (((i % 3) - 1) * 2.5) + 'deg');
    img.style.setProperty('--dur',   (5.3 + (i % 7) * 0.63).toFixed(2) + 's');
    img.style.setProperty('--delay', (-((i * 1.37) % 6)).toFixed(2) + 's');

    piece.appendChild(img);
    layer.appendChild(piece);
    flavourDecor.push({ img, pick:item.pick, w:item.w });
    decorItems.push({ img:piece, section, rot:0, depth:item.d || 0 });
  });

  syncFlavourDecor();
})();

/* Swap every piece to the active flavour's pair, fading out and back
   so nothing pops. Runs from select(), so the pills, the arrows and
   the keyboard all drive it identically. */
function syncFlavourDecor(){
  if (!flavourDecor || !flavourDecor.length) return;
  const pair = FLAVOUR_FRUIT[FLAVOURS[active].id];
  if (!pair) return;

  flavourDecor.forEach(slot => {
    const url = pair[slot.pick];
    if (!url || slot.current === url) return;
    slot.current = url;
    slot.img.classList.add('is-swapping');
    setTimeout(() => {
      responsive(slot.img, url, `${slot.w}vw`);
      slot.img.classList.remove('is-swapping');
    }, 260);
  });
}

/* Parallax: one rAF-throttled scroll handler for the whole layer.
   Offset is measured from each section's own centre, so pieces drift
   within their section rather than accumulating down the page. */
if (decorItems.length && !matchMedia('(prefers-reduced-motion: reduce)').matches){
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const mid = innerHeight / 2;
      decorItems.forEach(d => {
        const box = d.section.getBoundingClientRect();
        if (box.bottom < -200 || box.top > innerHeight + 200) return;
        const offset = ((box.top + box.height / 2) - mid) * -d.depth;
        d.img.style.transform = `translate3d(0, ${offset.toFixed(1)}px, 0) rotate(${d.rot}deg)`;
      });
      ticking = false;
    });
  };
  addEventListener('scroll', onScroll, { passive:true });
  onScroll();
}

/* ============================================================
   MARQUEES
   A -50% loop only reads as seamless if one "set" is wider than
   the container. Short sets leave a visible gap, so duplicate the
   content to width, then clone the whole set once.
   ============================================================ */
function buildMarquee(track){
  const source = track.dataset.mqSource || track.innerHTML;
  track.dataset.mqSource = source;

  const set = document.createElement('div');
  set.className = 'mq-set';
  set.innerHTML = source;
  track.innerHTML = '';
  track.appendChild(set);

  const target = (track.parentElement?.offsetWidth || innerWidth);
  let guard = 0;
  while (set.offsetWidth < target && guard++ < 12) set.innerHTML += source;

  track.appendChild(set.cloneNode(true));
}

const marquees = [...document.querySelectorAll('[data-marquee]')];
marquees.forEach(buildMarquee);

let mqTimer;
addEventListener('resize', () => {
  clearTimeout(mqTimer);
  mqTimer = setTimeout(() => marquees.forEach(buildMarquee), 250);
});

/* ============================================================
   HEADER + MOBILE NAV + REVEALS
   ============================================================ */
const header = document.getElementById('header');
addEventListener('scroll', () => header.classList.toggle('stuck', scrollY > 20), { passive:true });

const menuToggle = document.getElementById('menuToggle');
const nav = document.getElementById('nav');
menuToggle?.addEventListener('click', () => {
  const open = nav.classList.toggle('open');
  menuToggle.setAttribute('aria-expanded', open);
});
document.getElementById('navClose')?.addEventListener('click', () => {
  nav?.classList.remove('open');
  menuToggle?.setAttribute('aria-expanded', false);
});

nav?.addEventListener('click', e => {
  if (e.target.tagName === 'A'){
    nav.classList.remove('open');
    menuToggle.setAttribute('aria-expanded', false);
  }
});

const io = new IntersectionObserver(entries => {
  entries.forEach(en => { if (en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
}, { threshold:.15 });
document.querySelectorAll('.rv').forEach(el => io.observe(el));

/* Hero can follows the active flavour once the switcher is used */
const heroCan = document.getElementById('heroCan');
function syncHeroCan(){
  if (!heroCan) return;
  const f = FLAVOURS[active];
  heroCan.classList.remove('no-img');
  responsive(heroCan, f.img, '(max-width: 899px) 55vw, 30vw');
  heroCan.alt = `KAYTEA ${f.name} can`;
}
rail?.addEventListener('click', syncHeroCan);

/* Arrows wrap around, keep the rail scrolled to the active pill,
   and drive the same select() the pills do. */
function step(dir){
  select((active + dir + FLAVOURS.length) % FLAVOURS.length);
  syncHeroCan();
  centreRailPill();
}

/* scrollIntoView moves the page as well as the rail — vertically via
   block, horizontally via inline — and that sideways scroll was
   dragging the off-screen mobile nav panel into view. Scroll the rail
   element itself so nothing outside it moves. */
function centreRailPill(){
  const b = railBtns[active];
  if (!rail || !b) return;
  const left = b.offsetLeft - (rail.clientWidth - b.offsetWidth) / 2;
  rail.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
}
document.getElementById('flavPrev')?.addEventListener('click', () => step(-1));
document.getElementById('flavNext')?.addEventListener('click', () => step(1));